import { RouteConfig } from 'vue-router';
import MswBuildcheck from './msw-buildcheck.vue';

const mswBuildcheckRoute: RouteConfig = {
  path: 'buildcheck',
  component: MswBuildcheck,
};

export function getDefaultParams() {
  return {};
}

export default mswBuildcheckRoute;
